(function () {
    document.addEventListener('DOMContentLoaded', function () {
        const hamburger = document.querySelector(
            '.menu-walker-block__hamburger'
        );
        if (hamburger) {
            const container = hamburger
                .closest('.menu-walker-block')
                .querySelector('.menu-walker-block__container');

            hamburger.addEventListener('click', function () {
                hamburger.classList.toggle('open');
                container.classList.toggle('open');
            });
        }
        // Your code here
    });
})();
